export function getValue<T>(executor: SetAction<T>, value: T): T {
  if (executor instanceof Function) {
    return executor(value);
  }
  return executor;
}


export type SetAction<T> = T | ((val: T) => T)